/* eslint-disable */
// src/forms/local/createLocalForm.js

import React, { Component } from "react";
import localService from "../../services/localService";
import PersonService from "../../services/personService";
import PropTypes from "prop-types";
import {
  Button,
  TextField,
  Grid,
  Container,
  Paper,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Autocomplete,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormHelperText,
  Box,
  Alert,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import esLocale from "date-fns/locale/es";
import data from "../../assets/departamentos-y-ciudades.json";
import CancelButton from "components/common/CancelButton";
import AcceptButton from "components/common/AcceptButton";
import {
  getDefaultOperationDate,
  isValidOperationDate,
  isFutureOperationDate,
  toLocalDateOnlyString,
  parseDateOnlyToLocalDate,
  dateOnlyFromDateTime,
  isBeforeMinOperationDate,
} from "utils/operationDate";
import { secondaryOutlinedButtonSx } from "components/common/buttonStyles";
import {
  getPersonApiErrorMessage,
  normalizeOptionalText,
  normalizePersonOptionalFieldsForPayload,
} from "utils/personOptionalFields";

class CreateLocalForm extends Component {
  closedLocalsRequestId = 0;

  constructor(props) {
    super(props);
    this.state = {
      // Datos del local (Paso 2)
      local: {
        Name: "",
        Address: "",
        City: "",
        Stock: null,
        Type: "Comercio",
        LocalPersonId: "",
        Department: "",
      },

      // flags para distinguir campos auto-rellenados
      autoFill: {
        Address: false,
        Department: false,
        City: false,
      },

      // Datos para dueño EXISTENTE
      persons: [],
      personsLoadError: false,
      selectedPerson: null,
      closedLocals: [],
      closedLocalsLoading: false,
      closedLocalsError: "",
      reopenEffectiveDatesById: {},
      reopenErrorsById: {},
      reopenOperationErrorsById: {},
      reopenSubmittingId: null,

      // Datos para dueño (Paso 1)
      ownerMode: "",
      ownerError: "",
      newOwnerNameError: "",
      newPerson: {
        Name: "",
        Contact: "",
        Account: "",
        Address: "",
        City: "",
        Department: "",
        Type: "Cliente",
      },

      // selects de departamento/ciudad para LOCAL
      selectedDepartamento: "",
      selectedCiudad: "",

      // selects de departamento/ciudad para PERSONA nueva
      selectedPersonDepartamento: "",
      selectedPersonCiudad: "",

      // wizard
      step: 1, // 1 = dueño, 2 = local
      isLoading: true,
      submitting: false,
      creationDate: getDefaultOperationDate(),
      generalError: "",
      showLocalRequiredErrors: false,
    };
  }

  async componentDidMount() {
    try {
      const personsData = await PersonService.getAllClients();
      this.setState({
        persons: personsData,
        personsLoadError: false,
        selectedPerson: null,
        closedLocals: [],
        closedLocalsLoading: false,
        closedLocalsError: "",
        reopenEffectiveDatesById: {},
        reopenErrorsById: {},
        reopenSubmittingId: null,
        isLoading: false,
      });
    } catch (error) {
      console.error("Error fetching data:", error);
      this.setState({ isLoading: false, personsLoadError: true });
    }
  }

  // --------- Handlers generales ---------

  // cambios en campos del LOCAL (Paso 2)
  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState((prevState) => ({
      local: {
        ...prevState.local,
        [name]: value,
      },
      generalError: "",
      autoFill: {
        ...prevState.autoFill,
        ...(name === "Address" || name === "Department" || name === "City"
          ? { [name]: false }
          : {}),
      },
    }));
  };

  // Autocomplete de dueño EXISTENTE
  handleAutocompleteChange = async (_event, value) => {
    const reqId = ++this.closedLocalsRequestId;

    this.setState((prev) => ({
      local: { ...prev.local, LocalPersonId: value ? value.Id : "" },
      selectedPerson: value,
      closedLocals: [],
      closedLocalsLoading: !!value,
      closedLocalsError: "",
      reopenEffectiveDatesById: {},
      reopenErrorsById: {},
      reopenOperationErrorsById: {},
      ownerError: "",
      reopenSubmittingId: null,
    }));

    if (!value) return;

    try {
      const list = await localService.getClosedLocalsByOwner(value.Id);

      if (reqId !== this.closedLocalsRequestId) return;

      this.setState({
        closedLocals: Array.isArray(list) ? list : [],
        closedLocalsLoading: false,
      });
    } catch (error) {
      console.error("Error fetching closed locals by owner:", error);

      if (reqId !== this.closedLocalsRequestId) return;

      this.setState({
        closedLocals: [],
        closedLocalsLoading: false,
        closedLocalsError: "No se pudieron obtener locales cerrados. Reintentá o continuá con un local nuevo.",
      });
    }
  };

  formatClosedAt = (value) => {
    if (!value) return "—";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "—";
    return date.toLocaleString();
  };

  formatDateOnly = (value) => {
    if (!value) return "—";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "—";
    return date.toLocaleDateString("es-uy");
  };

  getReopenMinDate = (closedLocal) => {
    return parseDateOnlyToLocalDate(dateOnlyFromDateTime(closedLocal?.ClosedAt));
  };

  getReopenEffectiveDate = (closedLocal) => {
    const storedValue = this.state.reopenEffectiveDatesById?.[closedLocal?.Id];
    return storedValue || getDefaultOperationDate();
  };

  handleReopenDateChange = (localId, date) => {
    this.setState((prevState) => ({
      reopenEffectiveDatesById: {
        ...prevState.reopenEffectiveDatesById,
        [localId]: date,
      },
      reopenErrorsById: {
        ...prevState.reopenErrorsById,
        [localId]: "",
      },
    }));
  };

  getReopenDateError = (closedLocal) => {
    const effectiveDate = this.getReopenEffectiveDate(closedLocal);
    const minDate = this.getReopenMinDate(closedLocal);

    if (!isValidOperationDate(effectiveDate)) {
      return "Selecciona una fecha válida.";
    }
    if (isFutureOperationDate(effectiveDate)) {
      return "No se puede seleccionar una fecha futura.";
    }
    if (minDate && isBeforeMinOperationDate(effectiveDate, minDate)) {
      return "La fecha de reapertura no puede ser anterior al cierre del local.";
    }

    return "";
  };

  getReopenApiErrorMessage = (resp) => {
    if (resp?.code === "EFFECTIVE_DATE_CANNOT_BE_FUTURE") {
      return "No se puede seleccionar una fecha futura.";
    }
    if (resp?.code === "EFFECTIVE_DATE_BEFORE_LOCAL_CLOSED_AT") {
      return "La fecha de reapertura no puede ser anterior al cierre del local.";
    }
    return resp?.message || "No se pudo reabrir el local.";
  };

  handleReopenLocal = async (closedLocal) => {
    const { selectedPerson } = this.state;
    const localIdViejo = closedLocal?.Id;
    const reopenDateError = this.getReopenDateError(closedLocal);

    if (reopenDateError) {
      this.setState((prevState) => ({
        reopenErrorsById: {
          ...prevState.reopenErrorsById,
          [localIdViejo]: reopenDateError,
        },
      }));
      return;
    }

    let activePerson = selectedPerson;
    try {
      this.setState((prevState) => ({
        reopenSubmittingId: localIdViejo,
        reopenOperationErrorsById: {
          ...prevState.reopenOperationErrorsById,
          [localIdViejo]: "",
        },
        reopenErrorsById: {
          ...prevState.reopenErrorsById,
          [localIdViejo]: "",
        },
      }));

      if (activePerson?.Id && activePerson.IsActive === false) {
        const ok = await PersonService.reactivatePerson(activePerson.Id);
        if (!ok) {
          this.setState((prevState) => ({
            reopenOperationErrorsById: {
              ...prevState.reopenOperationErrorsById,
              [localIdViejo]: "No se pudo reactivar el dueño seleccionado.",
            },
          }));
          return;
        }
        activePerson = { ...activePerson, IsActive: true };
        this.setState({ selectedPerson: activePerson });
      }

      const reopenEffectiveDate = this.getReopenEffectiveDate(closedLocal);
      const resp = await localService.reopenLocal(localIdViejo, {
        EffectiveDate: toLocalDateOnlyString(reopenEffectiveDate),
      });
      if (resp?.conflict === true || resp?.invalid === true) {
        this.setState((prevState) => ({
          reopenErrorsById: {
            ...prevState.reopenErrorsById,
            [localIdViejo]: this.getReopenApiErrorMessage(resp),
          },
        }));
        return;
      }
      if (!resp || (!resp.id && !resp.local)) {
        this.setState((prevState) => ({
          reopenErrorsById: {
            ...prevState.reopenErrorsById,
            [localIdViejo]: "No se pudo reabrir el local.",
          },
        }));
        return;
      }

      const newLocalId = resp.id || resp.local?.Id;
      const fullLocal = {
        ...resp.local,
        Person: { ...(activePerson || {}), IsActive: true },
      };

      this.props.navigate(`/local/${newLocalId}`, {
        state: { local: fullLocal, justCreated: true },
      });
      this.props.closeForm();
    } catch (error) {
      console.error("Error reopening local:", error);
      this.setState((prevState) => ({
        reopenErrorsById: {
          ...prevState.reopenErrorsById,
          [localIdViejo]: "No se pudo reabrir el local.",
        },
      }));
    } finally {
      this.setState({ reopenSubmittingId: null });
    }
  };

  // Cambiar modo de dueño: existente vs nuevo
  setOwnerMode = (value) => {
    if (value !== "new") {
      this.setState({ ownerMode: value, ownerError: "", newOwnerNameError: "" });
      return;
    }

    this.closedLocalsRequestId += 1;

    this.setState((prev) => ({
      ownerMode: value,
      ownerError: "",
      newOwnerNameError: "",
      selectedPerson: null,
      local: { ...prev.local, LocalPersonId: "" },
      closedLocals: [],
      closedLocalsLoading: false,
      closedLocalsError: "",
      reopenEffectiveDatesById: {},
      reopenErrorsById: {},
      reopenOperationErrorsById: {},
      reopenSubmittingId: null,
    }));
  };

  handleOwnerModeChange = (event) => {
    this.setOwnerMode(event.target.value);
  };

  // --------- Handlers para PERSONA nueva (Paso 1) ---------

  handleNewPersonChange = (event) => {
    const { name, value } = event.target;
    this.setState((prevState) => ({
      newPerson: {
        ...prevState.newPerson,
        [name]: value,
      },
      ...(name === "Name" ? { newOwnerNameError: "" } : {}),
    }));
  };

  handlePersonDepartamentoChange = (event) => {
    const selectedPersonDepartamento = event.target.value;
    this.setState((prevState) => ({
      selectedPersonDepartamento,
      selectedPersonCiudad: "",
      newPerson: {
        ...prevState.newPerson,
        Department: selectedPersonDepartamento,
        City: "",
      },
    }));
  };

  handlePersonCiudadChange = (event) => {
    const selectedPersonCiudad = event.target.value;
    this.setState((prevState) => ({
      selectedPersonCiudad,
      newPerson: {
        ...prevState.newPerson,
        City: selectedPersonCiudad,
      },
    }));
  };

  // --------- Handlers para LOCAL (Paso 2) ---------

  handleDepartamentoChange = (event) => {
    const selectedDepartamento = event.target.value;
    this.setState((prevState) => ({
      selectedDepartamento,
      selectedCiudad: "",
      local: {
        ...prevState.local,
        Department: selectedDepartamento,
        City: "",
      },
      generalError: "",
      autoFill: {
        ...prevState.autoFill,
        Department: false,
      },
    }));
  };

  handleCiudadChange = (event) => {
    const selectedCiudad = event.target.value;
    this.setState((prevState) => ({
      selectedCiudad,
      local: {
        ...prevState.local,
        City: selectedCiudad,
      },
      generalError: "",
      autoFill: {
        ...prevState.autoFill,
        City: false,
      },
    }));
  };

  handleCreationDateChange = (date) => {
    this.setState({ creationDate: date, generalError: "" });
  };

  getLocalCreationDateError = () => {
    const { creationDate } = this.state;
    if (!isValidOperationDate(creationDate)) return "Selecciona una fecha válida.";
    if (isFutureOperationDate(creationDate)) return "No se puede seleccionar una fecha futura.";
    return "";
  };

  getApiErrorMessage = (error, fallback) => {
    const apiError = error?.response?.data?.error || fallback;
    const apiCode = error?.response?.data?.code || "";

    if (apiCode === "EFFECTIVE_DATE_CANNOT_BE_FUTURE") {
      return "No se puede seleccionar una fecha futura.";
    }

    return apiError || fallback;
  };

  // --------- Navegacion del wizard ---------

  // Paso 1 -> Paso 2 (pre-rellena datos del local con datos del dueño)
  handleNextStep = () => {
    const {
      ownerMode,
      selectedPerson,
      newPerson,
      persons,
      selectedPersonDepartamento,
      selectedPersonCiudad,
    } = this.state;

    if (ownerMode === "existing") {
      if (!selectedPerson) {
        if (!persons || persons.length === 0) {
          this.setState({ ownerError: "No hay contactos ingresados. Creá un nuevo contacto para continuar." });
        } else {
          this.setState({ ownerError: "Seleccioná un cliente existente antes de continuar." });
        }
        return;
      }

      this.setState((prevState) => {
        const dept = selectedPerson.Department || "";
        const city = selectedPerson.City || "";
        const addr = normalizeOptionalText(selectedPerson.Address) || "";

        const newLocal = {
          ...prevState.local,
          Address: prevState.local.Address || addr,
          Department: prevState.local.Department || dept,
          City: prevState.local.City || city,
        };

        return {
          step: 2,
          local: newLocal,
          selectedDepartamento: prevState.selectedDepartamento || dept,
          selectedCiudad: prevState.selectedCiudad || city,
          autoFill: {
            ...prevState.autoFill,
            Address: !prevState.local.Address && !!addr,
            Department: !prevState.local.Department && !!dept,
            City: !prevState.local.City && !!city,
          },
        };
      }, () => this.props.onStepChange(2, selectedPerson.Name?.trim()));
    } else if (ownerMode === "new") {
      if (!newPerson.Name.trim()) {
        this.setState({ newOwnerNameError: "Ingresá al menos el nombre del nuevo dueño." });
        return;
      }

      this.setState((prevState) => {
        const dept =
          newPerson.Department ||
          selectedPersonDepartamento ||
          "";
        const city =
          newPerson.City ||
          selectedPersonCiudad ||
          "";
        const addr = normalizeOptionalText(newPerson.Address) || "";

        const newLocal = {
          ...prevState.local,
          Address: prevState.local.Address || addr,
          Department: prevState.local.Department || dept,
          City: prevState.local.City || city,
        };

        return {
          step: 2,
          local: newLocal,
          selectedDepartamento: prevState.selectedDepartamento || dept,
          selectedCiudad: prevState.selectedCiudad || city,
          autoFill: {
            ...prevState.autoFill,
            Address: !prevState.local.Address && !!addr,
            Department: !prevState.local.Department && !!dept,
            City: !prevState.local.City && !!city,
          },
        };
      }, () => this.props.onStepChange(2, newPerson.Name.trim()));
    }
  };

  // Paso 2 -> Paso 1
  handlePrevStep = () => {
    this.setState({ step: 1 }, () => this.props.onStepChange(1));
  };

  // --------- Submit final (crea persona si es nueva y luego el local) ---------
  handleSubmit = async (event) => {
    event.preventDefault();

    if (this.state.step !== 2) {
      this.handleNextStep();
      return;
    }

    const { local } = this.state;
    if (!local.Address?.trim() || !local.Department || !local.City) {
      this.setState({ showLocalRequiredErrors: true, generalError: "" });
      return;
    }

    const creationDateError = this.getLocalCreationDateError();
    if (creationDateError) {
      return;
    }

    this.setState({ submitting: true, generalError: "" });

    try {
      const { ownerMode, newPerson, selectedPerson, creationDate } = this.state;

      let localPersonId = local.LocalPersonId;
      let personForLocal = null;

      // 1) Si el dueño es NUEVO -> crearlo
      if (ownerMode === "new") {
        const newPersonPayload = normalizePersonOptionalFieldsForPayload(newPerson);
        const created = await PersonService.createPerson(newPersonPayload);

        const createdPersonId = created?.id ?? created?.Id;
        if (!createdPersonId) {
          this.setState({ generalError: "No se pudo crear el dueño." });
          return;
        }

        localPersonId = createdPersonId;

        // Armamos un objeto Person para pasar a LocalMachine
        personForLocal = {
          Id: createdPersonId,
          ...(created.person || {}), // por si el backend devuelve "person"
          ...newPersonPayload, // aseguramos Name, Contact, etc.
        };
        } else {
        // 2) Dueño EXISTENTE -> ya lo tenemos en selectedPerson
        if (!selectedPerson) {
          this.setState({ step: 1, ownerError: "Seleccioná un cliente existente.", generalError: "" });
          return;
        }

        // Si el dueño seleccionado está inactivo, lo reactivamos primero  
        if (selectedPerson.IsActive === false) {
          const ok = await PersonService.reactivatePerson(selectedPerson.Id); 
          if (!ok) {  
            this.setState({ generalError: "No se pudo reactivar el dueño seleccionado." });
            return;
          }
        }

        localPersonId = selectedPerson.Id;
        personForLocal = { ...selectedPerson, IsActive: true };           
      }

      // 3) Crear el LOCAL
      const payloadLocal = {
        ...local,
        Stock: null,
        LocalPersonId: localPersonId,
        CreationDate: toLocalDateOnlyString(creationDate),
      };

      const createdLocal = await localService.createLocal(payloadLocal);
      const newLocalId = createdLocal?.id ?? createdLocal?.Id;

      if (!newLocalId) {
        this.setState({ generalError: "No se pudo crear el local." });
        return;
      }

      // 4) Construimos el local COMPLETO que usa LocalMachine
      const fullLocal = {
        ...createdLocal,
        ...payloadLocal,
        Id: newLocalId,
        Person: personForLocal,
      };

      // 5) Redirigimos a /local/:id con el local completo y la bandera justCreated
      this.props.navigate(`/local/${newLocalId}`, {
        state: { local: fullLocal, justCreated: true },
      });

      // 6) Cerramos el modal
      this.props.closeForm();
    } catch (error) {
      console.error(error);
      this.setState({
        generalError: getPersonApiErrorMessage(
          error,
          this.getApiErrorMessage(error, "Error creando local.")
        ),
      });
    } finally {
      this.setState({ submitting: false });
    }
  };

  render() {
    const {
      step,
      ownerMode,
      persons,
      personsLoadError,
      selectedPerson,
      isLoading,
      newPerson,
      local,
      selectedDepartamento,
      selectedCiudad,
      selectedPersonDepartamento,
      selectedPersonCiudad,
      submitting,
      autoFill,
      closedLocals,
      closedLocalsLoading,
      closedLocalsError,
      reopenErrorsById,
      reopenOperationErrorsById,
      reopenSubmittingId,
      creationDate,
      generalError,
      ownerError,
      newOwnerNameError,
      showLocalRequiredErrors,
    } = this.state;

    const noPersons = !persons || persons.length === 0;
    const hasSelectedExistingOwner =
      ownerMode === "existing" && Boolean(selectedPerson);
    const isCheckingClosedLocals =
      hasSelectedExistingOwner && closedLocalsLoading;
    const hasClosedLocals =
      hasSelectedExistingOwner && !closedLocalsLoading && closedLocals.length > 0;
    const shouldShowContinue =
      ownerMode === "new" ||
      (ownerMode === "existing" &&
        hasSelectedExistingOwner &&
        !isCheckingClosedLocals);
    const stepHeadingSx = {
      boxSizing: "border-box",
      width: "100%",
      m: 0,
      px: 1.5,
      py: 1,
      bgcolor: "action.selected",
      borderLeft: "3px solid",
      borderLeftColor: "primary.main",
      borderRadius: 1,
      color: "text.primary",
      fontSize: "0.95rem",
      fontWeight: 600,
      lineHeight: 1.35,
    };
    const ownerChoiceSx = (selected) => ({
      display: "flex",
      m: 0,
      px: 1.5,
      minHeight: 56,
      justifyContent: "center",
      alignItems: "center",
      textAlign: "center",
      border: 1,
      borderColor: selected ? "primary.main" : "divider",
      borderRadius: 1,
      bgcolor: selected ? "action.selected" : "background.paper",
      "&:hover": { borderColor: "primary.main" },
      "& .MuiFormControlLabel-label": { fontSize: "0.875rem", fontWeight: 600 },
    });

    return (
      <Container component={Paper} style={{ padding: "20px", marginTop: "20px" }}>
        <form onSubmit={this.handleSubmit} noValidate>
          <Grid container spacing={2}>
            {/* PASO 1: Dueño */}
            {step === 1 && (
              <>
                <Grid item xs={12}>
                  <FormControl component="fieldset" fullWidth>
                    <Box component="legend" sx={stepHeadingSx}>Dueño</Box>
                    <RadioGroup
                      value={ownerMode}
                      onChange={this.handleOwnerModeChange}
                      sx={{
                        display: "grid",
                        gridTemplateColumns: { xs: "1fr", sm: "repeat(2, minmax(0, 1fr))" },
                        gap: 1.5,
                        mt: 1.5,
                      }}
                    >
                      <FormControlLabel
                        value="existing"
                        control={<Radio />}
                        label="Usar contacto existente"
                        sx={ownerChoiceSx(ownerMode === "existing")}
                      />
                      <FormControlLabel
                        value="new"
                        control={<Radio />}
                        label="Crear nuevo contacto"
                        sx={ownerChoiceSx(ownerMode === "new")}
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>

                {/* Modo: dueño existente */}
                {ownerMode === "existing" && (
                  <Grid item xs={12}>
                    {isLoading ? (
                      <FormHelperText>Cargando contactos...</FormHelperText>
                    ) : personsLoadError ? (
                      <Box sx={{ color: "error.main" }}>
                        No se pudieron cargar los contactos. Cerrá el formulario y volvé a intentarlo.
                      </Box>
                    ) : noPersons ? (
                      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 1 }}>
                        <Box sx={{ color: "text.secondary" }}>
                          Todavía no hay contactos. Creá uno nuevo para continuar.
                        </Box>
                        <Button
                          variant="outlined"
                          sx={secondaryOutlinedButtonSx}
                          onClick={() => this.setOwnerMode("new")}
                        >
                          Crear nuevo contacto
                        </Button>
                      </Box>
                    ) : (
                      <Autocomplete
                        options={persons}
                        getOptionLabel={(option) => option.Name}
                        value={selectedPerson}
                        onChange={this.handleAutocompleteChange}
                        renderOption={(props, option) => ( 
                          <li
                            {...props}
                            style={{
                              color: option.IsActive ? "inherit" : "#9E9E9E",
                            }}
                          >
                            {option.Name}
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Cliente"
                            required
                            error={Boolean(ownerError)}
                            helperText={ownerError}
                            sx={{
                              "& .MuiInputLabel-root:not(.MuiInputLabel-shrink)": {
                                lineHeight: 1.25,
                                transform: "translate(14px, 19px) scale(1)",
                              },
                            }}
                          />
                        )}
                        disabled={isLoading}
                      />
                    )}
                  </Grid>
                )}

                {ownerMode === "existing" && selectedPerson && (
                  <Grid item xs={12}>
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                      {closedLocalsLoading && (
                        <FormHelperText>Buscando locales cerrados...</FormHelperText>
                      )}

                      {!!closedLocalsError && (
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
                          <FormHelperText error sx={{ m: 0 }}>{closedLocalsError}</FormHelperText>
                          <Button
                            variant="outlined"
                            sx={secondaryOutlinedButtonSx}
                            onClick={() => this.handleAutocompleteChange(null, selectedPerson)}
                          >
                            Reintentar
                          </Button>
                        </Box>
                      )}

                      {hasClosedLocals && (
                        <>
                          <Box
                            component="h3"
                            sx={{
                              m: 0,
                              px: 1.5,
                              py: 1,
                              bgcolor: "action.hover",
                              borderLeft: "2px solid",
                              borderLeftColor: "primary.main",
                              borderRadius: 1,
                              color: "text.primary",
                              fontSize: "0.95rem",
                              fontWeight: 600,
                              lineHeight: 1.35,
                            }}
                          >
                            Locales anteriores
                          </Box>
                          {closedLocals.map((item) => (
                            <Paper
                              key={item.Id}
                              variant="outlined"
                              sx={{ p: 1.5 }}
                            >
                              <Box>
                                <Box><strong>Nombre:</strong> {item.Name || "Sin nombre"}</Box>
                                <Box><strong>Dirección:</strong> {item.Address || "—"}, {item.City || "—"}, {item.Department || "—"}</Box>
                                {(() => {
                                  const periods = (Array.isArray(item.Periods) ? item.Periods : [])
                                    .filter((p) => p?.IsActive !== true && p?.CreatedAt && p?.ClosedAt)
                                    .sort((a, b) => (Number(a.CycleNumber) || 0) - (Number(b.CycleNumber) || 0))
                                    .map((p) => `${this.formatDateOnly(p.CreatedAt)} → ${this.formatDateOnly(p.ClosedAt)}`);

                                  if (!periods.length) return null;

                                  return (
                                    <Box>
                                      <Box><strong>Períodos anteriores:</strong></Box>
                                      {periods.map((period, index) => (
                                        <Box key={`${item.Id}-${index}`}>{period}</Box>
                                      ))}
                                    </Box>
                                  );
                                })()}
                              </Box>
                              <Box
                                sx={{
                                  mt: 2,
                                  display: "flex",
                                  flexDirection: { xs: "column", sm: "row" },
                                  alignItems: "flex-start",
                                  gap: 1.5,
                                }}
                              >
                                <Box sx={{ flex: 2, width: "100%", minWidth: 0 }}>
                                  <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={esLocale}>
                                    <DatePicker
                                      label="Fecha de reapertura"
                                      value={this.getReopenEffectiveDate(item)}
                                      onChange={(date) => this.handleReopenDateChange(item.Id, date)}
                                      minDate={this.getReopenMinDate(item) || undefined}
                                      maxDate={getDefaultOperationDate()}
                                      slotProps={{
                                        textField: {
                                          fullWidth: true,
                                          required: true,
                                          error: Boolean(
                                            reopenErrorsById[item.Id] || this.getReopenDateError(item)
                                          ),
                                          helperText:
                                            reopenErrorsById[item.Id] || this.getReopenDateError(item),
                                        },
                                      }}
                                    />
                                  </LocalizationProvider>
                                </Box>
                                <Box sx={{ flex: 1, width: "100%", minWidth: 0 }}>
                                  <Button
                                    variant="outlined"
                                    fullWidth
                                    onClick={() => this.handleReopenLocal(item)}
                                    disabled={reopenSubmittingId === item.Id}
                                    sx={{ ...secondaryOutlinedButtonSx, height: 48 }}
                                  >
                                    {reopenSubmittingId === item.Id ? "Reabriendo..." : "Reabrir"}
                                  </Button>
                                </Box>
                              </Box>
                              {reopenOperationErrorsById[item.Id] && (
                                <FormHelperText error>{reopenOperationErrorsById[item.Id]}</FormHelperText>
                              )}
                            </Paper>
                          ))}
                        </>
                      )}
                    </Box>
                  </Grid>
                )}

                {/* Modo: dueño nuevo */}
                {ownerMode === "new" && (
                  <>
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        label="Nombre"
                        required
                        name="Name"
                        value={newPerson.Name}
                        onChange={this.handleNewPersonChange}
                        error={Boolean(newOwnerNameError)}
                        helperText={newOwnerNameError}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        label="Celular"
                        name="Contact"
                        value={newPerson.Contact ?? ""}
                        onChange={this.handleNewPersonChange}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        label="Cuenta"
                        name="Account"
                        value={newPerson.Account ?? ""}
                        onChange={this.handleNewPersonChange}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <FormControl fullWidth>
                        <InputLabel>Departamento</InputLabel>
                        <Select
                          value={selectedPersonDepartamento}
                          onChange={this.handlePersonDepartamentoChange}
                          label="Departamento"
                        >
                          {data.map((departamento) => (
                            <MenuItem key={departamento.id} value={departamento.name}>
                              {departamento.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} md={8}>
                      <TextField
                        fullWidth
                        label="Dirección"
                        name="Address"
                        value={newPerson.Address ?? ""}
                        onChange={this.handleNewPersonChange}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <FormControl
                        fullWidth
                        disabled={!selectedPersonDepartamento}
                      >
                        <InputLabel>Ciudad</InputLabel>
                        <Select
                          value={selectedPersonCiudad}
                          onChange={this.handlePersonCiudadChange}
                          label="Ciudad"
                        >
                          {data
                            .find(
                              (departamento) =>
                                departamento.name === selectedPersonDepartamento
                            )
                            ?.towns.map((ciudad) => (
                              <MenuItem key={ciudad.id} value={ciudad.name}>
                                {ciudad.name}
                              </MenuItem>
                            ))}
                        </Select>
                      </FormControl>
                    </Grid>
                  </>
                )}

                {/* Botones paso 1: Cancelar (izquierda) / Continuar (derecha) */}
                <Grid item xs={12} sx={{ mt: 1 }}>
                  <Box display="flex" flexDirection={{ xs: "column", md: "row" }} gap={2} sx={{ width: "100%", "& > button": { flex: 1, minWidth: 0 } }}>
                    <CancelButton onClick={this.props.closeForm} fullWidth>
                      Cancelar
                    </CancelButton>

                    <AcceptButton
                      onClick={this.handleNextStep}
                      disabled={!shouldShowContinue || isCheckingClosedLocals}
                      fullWidth
                    >
                      {hasClosedLocals || closedLocalsError ? "Continuar con un local nuevo" : "Continuar"}
                    </AcceptButton>
                  </Box>
                </Grid>
              </>
            )}

            {/* PASO 2: Datos del local */}
            {step === 2 && (
              <>
                <Grid item xs={12}>
                  <Box component="h3" sx={stepHeadingSx}>Local</Box>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Nombre del local"
                    name="Name"
                    value={local.Name}
                    onChange={this.handleChange}
                  />
                </Grid>
                {(autoFill.Address || autoFill.Department || autoFill.City) && (
                  <Grid item xs={12}>
                    <FormHelperText sx={{ mt: 0, color: "text.main" }}>
                      Dirección sugerida del dueño.
                    </FormHelperText>
                  </Grid>
                )}
                <Grid item xs={12}>
                  <FormControl fullWidth required error={showLocalRequiredErrors && !local.Department}>
                    <InputLabel>Departamento</InputLabel>
                    <Select
                      value={selectedDepartamento}
                      onChange={this.handleDepartamentoChange}
                      label="Departamento"
                      sx={autoFill.Department ? { color: "#9E9E9E" } : {}}
                    >
                      {data.map((departamento) => (
                        <MenuItem key={departamento.id} value={departamento.name}>
                          {departamento.name}
                        </MenuItem>
                      ))}
                    </Select>
                    {showLocalRequiredErrors && !local.Department && (
                      <FormHelperText>Seleccioná un departamento.</FormHelperText>
                    )}
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={8}>
                  <TextField
                    fullWidth
                    label="Dirección"
                    required
                    name="Address"
                    value={local.Address}
                    onChange={this.handleChange}
                    error={showLocalRequiredErrors && !local.Address?.trim()}
                    helperText={showLocalRequiredErrors && !local.Address?.trim() ? "Ingresá una dirección." : ""}
                    InputProps={{
                      style: autoFill.Address ? { color: "#9E9E9E" } : {},
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <FormControl
                    fullWidth
                    required
                    disabled={!selectedDepartamento}
                    error={showLocalRequiredErrors && !local.City}
                    sx={showLocalRequiredErrors && !local.City && !selectedDepartamento ? {
                      "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline": {
                        borderColor: "error.main",
                      },
                    } : undefined}
                  >
                    <InputLabel>Ciudad</InputLabel>
                    <Select
                      value={selectedCiudad}
                      onChange={this.handleCiudadChange}
                      label="Ciudad"
                      sx={autoFill.City ? { color: "#9E9E9E" } : {}}
                    >
                      {data
                        .find(
                          (departamento) =>
                            departamento.name === selectedDepartamento
                        )
                        ?.towns.map((ciudad) => (
                          <MenuItem key={ciudad.id} value={ciudad.name}>
                            {ciudad.name}
                          </MenuItem>
                        ))}
                    </Select>
                    {showLocalRequiredErrors && !local.City && (
                      <FormHelperText>
                        {selectedDepartamento ? "Seleccioná una ciudad." : "Seleccioná primero un departamento para elegir la ciudad."}
                      </FormHelperText>
                    )}
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={esLocale}>
                    <DatePicker
                      label="Fecha de creación"
                      value={creationDate}
                      onChange={this.handleCreationDateChange}
                      maxDate={getDefaultOperationDate()}
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          required: true,
                          error: Boolean(this.getLocalCreationDateError()),
                          helperText: this.getLocalCreationDateError(),
                        },
                      }}
                    />
                  </LocalizationProvider>
                </Grid>

                {generalError && (
                  <Grid item xs={12}>
                    <Alert severity="error" onClose={() => this.setState({ generalError: "" })}>
                      {generalError}
                    </Alert>
                  </Grid>
                )}

                {/* Botones paso 2: Atrás (izquierda) / Crear Local (derecha) */}
                <Grid item xs={12} sx={{ mt: 1 }}>
                  <Box display="flex" flexDirection={{ xs: "column", md: "row" }} gap={2} sx={{ width: "100%", "& > button": { flex: 1, minWidth: 0 } }}>
                    <CancelButton onClick={this.handlePrevStep} disabled={submitting} fullWidth>
                      Atrás
                    </CancelButton>

                    <AcceptButton
                      type="submit"
                      disabled={submitting || Boolean(this.getLocalCreationDateError())}
                      fullWidth
                    >
                      {submitting ? "Creando..." : "Crear local"}
                    </AcceptButton>
                  </Box>
                </Grid>
              </>
            )}
          </Grid>
        </form>
      </Container>
    );
  }
}

CreateLocalForm.propTypes = {
  closeForm: PropTypes.func.isRequired,
  navigate: PropTypes.func.isRequired,
  onStepChange: PropTypes.func.isRequired,
};

export default CreateLocalForm;






